import {Component, Input, Output, EventEmitter} from "@angular/core";
import {LocalizationCodeService} from "../../localization-code/localization-code.service";
import {DeviceGqlModel, LocalizationCodeItemModel} from "../../device/device.gql-model";
import {FilteredList} from "../../helpers/filtered-list";

@Component({
  selector: "localization-code-input",
  templateUrl: "./localization-code-input.template.pug",
})
export class LocalizationCodeInput {
  @Output() inputModelChange = new EventEmitter<string>();

  constructor(public localizationCodeService: LocalizationCodeService) {}

  @Input() localizationCode: LocalizationCodeItemModel;
  @Input() inputModel: string;
  @Input() device: DeviceGqlModel;
  @Input() devices: FilteredList<DeviceGqlModel>;
  timeToSearch: any;
  loading: boolean = false;

  clearLocalizationCode(localizationCode) {
    localizationCode.id = "";
    localizationCode.localizationDescription = "";
    localizationCode.selected = false;
  }

  async searchLocalizationCode(localizationCode, device) {
    try {
      this.loading = true;
      if (!localizationCode.localizationCode.trim().length) {
        localizationCode.id = "";
        localizationCode.localizationCode = "";
        localizationCode.localizationDescription = "";
        localizationCode.selected = false;
        localizationCode.error = "";
        return localizationCode;
      }
      const result = await this.localizationCodeService.getLocalizationCode(localizationCode.localizationCode);
      if (result.id) {
        const existingAvailableLocalizationCode = device.availableLocalizationCodes.find(lc => lc.id === result.id);
        result.isDefault = !!existingAvailableLocalizationCode;

        if (device.localizationCodes.some(lc => lc.id === result.id)) {
          localizationCode.error = "Localization Code is already added.";
          this.clearLocalizationCode(localizationCode);
        } else {
          localizationCode.id = result.id;
          localizationCode.localizationDescription = result.localizationDescription;
          localizationCode.error = "";
          localizationCode.selected = true;
          this.devices.form.markAsDirty();
        }
      } else {
        localizationCode.error = "Localization Code does not exist.";
        this.clearLocalizationCode(localizationCode);
      }
      return localizationCode;
    } finally {
      this.loading = false;
    }
  }

  keyUp() {
    clearTimeout(this.timeToSearch);
    this.timeToSearch = setTimeout(() => {
      this.searchLocalizationCode(this.localizationCode, this.device);
    }, 1000);
  }
}
